<section class="reminderOptionsList">
  <header class="reminderOptionsList__header">{{ ppOptions().label | titlecase }}</header>

  <section class="reminderOptionsList__options">
    <button class="reminderOptionsList__selectAll" (click)="toggleAll()">
      {{ (allSelected ? 'deselect_all' : 'select_all') | ppTranslate }}
    </button>

    @for (option of ppOptions().options; track option.value) {
      <pp-checkbox
        [ppChecked]="option.selected"
        (ppOnValueChange)="changeOption(option)"
        ppType="solid"
      >
        <span class="reminderOptionsList__label">{{ option.label }}</span>
      </pp-checkbox>
    }
  </section>
</section>
